import { render, staticRenderFns } from "./SafetyRightAnnotations.vue?vue&type=template&id=36ac4803&scoped=true&"
import script from "./SafetyRightAnnotations.vue?vue&type=script&lang=js&"
export * from "./SafetyRightAnnotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac4803",
  null
  
)

export default component.exports